import React from 'react'
import ReactDOM from 'react-dom'
import Questionnaire from "./components/Questionnaire"

// needed for hot reloading to work and not do a full refresh
// if (module.hot)
//   module.hot.accept()


function mainRender(props) {
  ReactDOM.render(
    <Questionnaire {...props} />,
    document.getElementById('form-container')
  )
}


export default {
  init: mainRender
}